import React from 'react';
import PropTypes from 'prop-types';
import StyledErrorPage from './Toast.styles';

const ToastContext = React.createContext();

const TOAST_DURATION = 3000;

class ToastProvider extends React.Component {
  state = {
    toast: null
  };

  static propTypes = {
    children: PropTypes.node.isRequired
  };

  createToast = (toast) => {
    this.setState({
      toast
    });
    setTimeout(() => {
      this.setState({
        toast: null
      });
    }, TOAST_DURATION);
  };

  render() {
    const { children } = this.props;
    const { toast } = this.state;

    return (
      <ToastContext.Provider
        value={{
          toast,
          createToast: this.createToast
        }}
      >
        <StyledErrorPage>{children}</StyledErrorPage>
      </ToastContext.Provider>
    );
  }
}

export default ToastContext.Consumer;
export { ToastContext, ToastProvider };
